module.exports = __webpack_public_path__ + "static/4-f368db1271b6cd060f7c6dc996a71eb8.png";